<div class="dm-page-content mb-25">
  <div class="container-fluid">
    <div class="row">
      <div class="col-12">
        <app-back-button />
        <div class="page-header">
          <div class="left-area">
            <span class="title">Empresas Gestoras</span>
            <span class="sub-title">Adicione, consulte e edite empresas gestoras</span>
          </div>
          <div class="indicator" *ngIf="empresasCount">
            <div class="indicator">
              <div class="icon">
                <img src="icons/building-03.svg" alt="Country Icon" />
              </div>
              <div class="text-bg">
                <span>{{empresasCount}} Empresas Gestoras</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="input_contetnt">
      <app-search-bar [showFilterBtn]="true" (onFilterBtnClick)="showFilterModal()" [sortFields]="sortFields"
        primaryBtnLabel="Nova Empresa Gestora" (onPrimaryBtnClick)="showDialog()"
        (formValueChange)="onFormValueChange($event)"></app-search-bar>
    </div>
    <div class="row">
      <div class="col-12">
        <ng-container *ngIf="insttuicaoGestoraList.length; else noData">
          <div class="list grid">
            <app-card-empresa-03 *ngFor="let item of pagination.data" class="col-6"
              [routerLink]="['detalhe-instituicao-gestora', item.id]" [foto]="imagePreviewMap[item.id]"
              [nome]="item.nome" [endereco]="item.endereco" [email]="item.email" [telefone]="item.telefone1"
              [site]="item.site" [natureza]="item.naturezaDescricao" [activo]="item.activo" [empresa]="item" [provincia]="item.provincia">
            </app-card-empresa-03>
          </div>

          <div class="pagination-controls">
            <app-paginator-control [first]="((pagination.pageNumber ?? 1) - 1) * (pagination.pageSize ?? 10)"
              [rows]="pagination.pageSize ?? 10" [totalRecords]="pagination.totalRecords ?? 0"
              (pageChange)="onPageChange($event)">
            </app-paginator-control>
          </div>
        </ng-container>
        <ng-template #noData>
          <div class="no-data">
            <app-data-void titulo="Nenhuma Empresa Gestora encontrada"
              descricao="Clique em Nova Empresa Gestora para criar uma."></app-data-void>
          </div>
        </ng-template>
      </div>
    </div>
  </div>
  <p-toast></p-toast>

  <p-dialog header="Filtros" [modal]="true" [(visible)]="showFilter" [style]="{ width: '40rem' }" appendTo="body">

    <form [formGroup]="form" class="p-fluid grid">
      <div *ngFor="let filter of filters" class="field col-6 d-flex flex-column">
        <label>{{ filter.placeholder }}</label>

        <!-- Se for dropdown -->
        <p-select *ngIf="filter.type === 'dropdown'" [filter]="true" [showClear]="true" appendTo="body"
          [options]="filter.options" [formControlName]="filter.controlName" [placeholder]="filter.placeholder"
          [optionLabel]="filter.optionLabel" [optionValue]="filter.optionValue">
        </p-select>

        <!-- Se for texto -->
        <input *ngIf="filter.type === 'text'" pInputText [formControlName]="filter.controlName"
          [placeholder]="filter.placeholder" class="w-full" />
      </div>
    </form>


    <div class="flex items-center justify-content-between">
      <p-button label="Cancelar" severity="secondary" (click)="showFilter = false" />
      <p-button label="Pesquisar" (click)="handleFormValueChange(form.value)" />
    </div>
  </p-dialog>